import {
  Directive,
  NgZone,
  Injector,
  Renderer2,
  ElementRef,
  AfterViewInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import {
  dropHandlers,
  smoothDnD as SmoothDndForVisible,
  DropResult,
  ContainerOptions,
  constants,
} from "@farris/smooth-dnd";

const { wrapperClass, animationClass } = constants;
SmoothDndForVisible.dropHandler = dropHandlers.reactDropHandler().handler;
SmoothDndForVisible.wrapChild = false;

export interface DragStartEndInfo {
  isSource: boolean;
  payload: any;
  willAcceptDrop: boolean;
}

@Directive({
  selector: "[upfile-order-drag]",
})
export class UploadFileOrderDragDirective implements AfterViewInit, OnDestroy {
  private container: any;
  @Input('upfile-order-drag') enableDrag = false;
  @Output() drop = new EventEmitter();
  @Input() options: ContainerOptions = {
    behaviour: "move",
    dragHandleSelector: ".upfile-drag-handle",
    dropPlaceholder: {
      className: "drop-group-field",
    },
    getGhostParent: () => {
      return document.body;
    },
    getChildPayload: this.getChildPayload.bind(this),
    shouldAcceptDrop: (sourceContainerOptions, payload) => {
      return true;
    },
    onDropReady: (dropResult: DropResult) => {
      this.ngzone.run(() => {
        this.onDropReady(dropResult);
      });
    },
    onDrop: (dropResult: DropResult) => {
      this.ngzone.run(() => {
        this.drop.emit(dropResult);
      });
    },
    onDragEnter: () => {
      this.ngzone.run(() => {
        this.onDragEnter();
      });
    },
    onDragStart: (info: DragStartEndInfo) => {
      this.ngzone.run(() => {
        this.onDragStart(info);
      });
    },
    onDragEnd: (info: DragStartEndInfo) => {
      this.ngzone.run(() => {
        this.onDragEnd(info);
      });
    },
  };

  constructor(
    private ngzone: NgZone,
    private injector: Injector,
    private render: Renderer2,
    private el: ElementRef
  ) {}
  ngAfterViewInit() {
    if (this.enableDrag) {
        this.initDnD();
    }
  }

  ngOnDestroy() {
    this.disposeDnd();
  }

  private disposeDnd() {
    if (this.container) {
      this.container.dispose();
      this.container = null;
    }
  }

  private initDnD() {
    this.disposeDnd();
    this.container = SmoothDndForVisible(this.el.nativeElement, this.options);
  }

  private getChildPayload(index) {
    return index;
  }

  private onDropReady(dropResult) {
    // console.log('DROP READY', dropResult);
  }

  private onDragStart(info) {
    // console.log("DRAG START", info);
  }

  private onDragEnd(info) {
    // console.log('DRAG END', info);
  }

  private onDragEnter() {
    // console.log('DRAG ENTER');
  }
}
